// FieldVision Admin - Header Component v2.0
// Tilfojet: Brugere navigation
import React from 'react';
import { logout } from '../services/api';

type View = 'orders' | 'users' | 'pilots';

interface AdminHeaderProps {
  currentView: View;
  onNavigate: (view: View) => void;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ currentView, onNavigate }) => {
  const handleLogout = () => {
    if (window.confirm('Er du sikker paa at du vil logge ud?')) {
      logout();
    }
  };

  return (
    <header style={styles.header}>
      <div style={styles.left}>
        <span style={styles.logo}>&#127806;</span>
        <h1 style={styles.title}>FieldVision Admin</h1>
      </div>

      <nav style={styles.nav}>
        <button
          onClick={() => onNavigate('orders')}
          style={{
            ...styles.navButton,
            ...(currentView === 'orders' ? styles.navButtonActive : {}),
          }}
        >
          &#128203; Ordrer
        </button>
        <button
          onClick={() => onNavigate('users')}
          style={{
            ...styles.navButton,
            ...(currentView === 'users' ? styles.navButtonActive : {}),
          }}
        >
          &#128100; Brugere
        </button>
        <button
          onClick={() => onNavigate('pilots')}
          style={{
            ...styles.navButton,
            ...(currentView === 'pilots' ? styles.navButtonActive : {}),
          }}
        >
          &#128104;&#8205;&#9992;&#65039; Piloter
        </button>
      </nav>

      <button onClick={handleLogout} style={styles.logoutButton}>
        Log ud
      </button>
    </header>
  );
};

const styles: Record<string, React.CSSProperties> = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 24px',
    backgroundColor: 'white',
    borderBottom: '1px solid #e5e7eb',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  logo: {
    fontSize: '28px',
  },
  title: {
    margin: 0,
    fontSize: '20px',
    fontWeight: 600,
    color: '#1f2937',
  },
  nav: {
    display: 'flex',
    gap: '8px',
  },
  navButton: {
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: 500,
    color: '#6b7280',
    backgroundColor: 'transparent',
    border: '1px solid transparent',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  navButtonActive: {
    color: '#16a34a',
    backgroundColor: '#f0fdf4',
    borderColor: '#bbf7d0',
  },
  logoutButton: {
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: 500,
    color: '#6b7280',
    backgroundColor: 'transparent',
    border: '1px solid #e5e7eb',
    borderRadius: '6px',
    cursor: 'pointer',
  },
};

export default AdminHeader;
